import "./ResultsStrip.css";

const CLIENTS = [
    { name: "Annie Elise / 10 to LIFE", subs: "1.2M subscribers" },
    { name: "Manchurek Triplets", subs: "9.07M subscribers" },
    { name: "Boys & Girls Hairstyles", subs: "233K subscribers" },
    { name: "Hidden True Crime", subs: "378K subscribers" },
];

export const ResultsStrip = () => {
    return (
        <section className="results" id="results" data-testid="results-strip">
            <div className="results-inner">
                <p className="results-label" data-testid="results-label">
                    Channels We Edit For
                </p>
                <div className="results-cards">
                    {CLIENTS.map((client) => (
                        <div
                            className="results-card"
                            key={client.name}
                            data-testid={`results-card-${client.name
                                .toLowerCase()
                                .replace(/[^a-z0-9]+/g, "-")}`}
                        >
                            <span className="results-card-name">
                                {client.name}
                            </span>
                            <span className="results-card-subs">
                                <span
                                    className="results-card-dot"
                                    aria-hidden="true"
                                />
                                {client.subs}
                            </span>
                        </div>
                    ))}
                </div>
                <p className="results-scroll-hint" data-testid="results-scroll-hint">
                    Scroll for more!
                </p>
            </div>
        </section>
    );
};
